import React, { Component } from 'react';
import classNames from 'classnames';


class UserMessages extends Component {
  static getDomId() {
    return 'error_user_messages';
  }

  constructor() {
    super();
    this.state = {
      showError: false,
      animateIn: false,
      detail: {},
    };
    this.showUserErrorMessage = this.showUserErrorMessage.bind(this);
  }

  componentDidMount() {
    const handlers = {
      showUserErrorMessage: this.showUserErrorMessage,
    };

    this.handlers = window.subscribeToMarketplaceEvents(handlers);
  }

  componentWillUnmount() {
    window.unsubscribeFromMarketplaceEvents(this.handlers);
  }

  showUserErrorMessage(event) {
    const { detail } = event;
    const waitForAnimationMs = 250;

    this.setState({
      detail,
      showError: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          animateIn: true,
        });
      }, waitForAnimationMs);
    });
  }

  render() {
    const { showError, animateIn, detail } = this.state;
    const pageErrorClass = classNames({
      'page-error': true,
      'page-error--animate-in': animateIn,
    });

    if (!showError) {
      return null;
    }

    return (
      <div className={pageErrorClass}>
        <div className="page-error__wrapper">
          <h1 className="page-error__title">{detail.headline}</h1>
          <div className="page-error__content">
            <div className="page-error__content-row">
              <div className="page-error__text">
                <p>{detail.message}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserMessages;
